import { Link, Paragraph, XStack } from "@/components";
import SkipOrSubmit from "@/conversation/AskUserQuestionsPanel/SkipOrSubmit";
import type { MedicationHistoryCopy } from "./copy";

/** The disclosure line and Skip under the consent step. */
export default function ConsentFooter({
  copy,
  onSkip,
}: {
  copy: MedicationHistoryCopy;
  onSkip: () => void;
}) {
  return (
    <XStack
      alignItems="center"
      gap="$200"
      paddingHorizontal="$150"
      paddingTop="$150"
    >
      <Paragraph size="$sm" color="$textSecondary" flex={1}>
        {copy.disclosure}{" "}
        <Link size="$sm" external semibold href={copy.linkHref}>
          {copy.linkLabel}
        </Link>{" "}
        {copy.disclosureSuffix}
      </Paragraph>
      <SkipOrSubmit isLast onSkip={onSkip} onSubmit={onSkip} />
    </XStack>
  );
}
